import { ref, watch } from '@vue/composition-api'
import store from '@/store'

export default function controller() {
  const blankItem = {
    id: null,
    profile: '',
    caracteristic: '',
    level_of_support: '',
  }

  const form = ref(null)
  const items = ref([])
  const item = ref({})

  const tableColumns = [
    {
      text: 'Profil',
      value: 'profile',
    },
    {
      text: 'Caractéristique',
      value: 'caracteristic',
    },
    {
      text: "Niveau d'accompagnement",
      value: 'level_of_support',
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]

  const isSnackbarBottomVisible = ref(false)
  const snackBarMessage = ref('')
  const isFormActive = ref(false)
  const deleteDialog = ref(false)
  const searchQuery = ref('')
  const totalItems = ref(0)
  const loading = ref(false)
  const options = ref({
    rowsPerPage: 10,
    page: 1,
    sortDesc: [false],
  })

  const page = ref(1)
  const pageCount = ref(0)
  const selectedRows = ref([])

  const resetForm = () => {
    if (form.value) {
      form.value.reset()
    }
  }

  const openDialog = val => {
    if (val) {
      item.value = val
    } else {
      item.value = JSON.parse(JSON.stringify(blankItem))
      resetForm()
    }

    isFormActive.value = !isFormActive.value
  }

  const fetchItems = () => {
    isFormActive.value = false

    loading.value = true

    store
      .dispatch('authorEvaluation/fetchItems', {
        term: searchQuery.value,
        orderBy: options.value.sortBy
          ? (options.value.sortBy[0] || 'id')
          : 'id',
        direction: options.value.sortDesc
          ? (options.value.sortDesc[0] ? 'DESC' : 'ASC')
          : 'DESC',
        page: options.value.page,
        per_page: options.value.itemsPerPage,
      })
      .then(response => {
        const { data, total } = response.data

        items.value = data
        totalItems.value = total
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        loading.value = false
      })
  }

  const confirmDelete = val => {
    item.value = val
    deleteDialog.value = true
  }

  const deleteItem = () => {
    if (item.value) {
      store
        .dispatch('authorEvaluation/deleteItem', item.value.id)
        .then(() => {
          deleteDialog.value = false
          fetchItems()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  watch([searchQuery, options], () => {
    loading.value = true
    selectedRows.value = []
    fetchItems()
  })

  return {
    item,
    items,
    tableColumns,
    searchQuery,
    totalItems,
    loading,
    options,
    selectedRows,
    isFormActive,
    blankItem,
    form,
    page,
    pageCount,
    snackBarMessage,
    isSnackbarBottomVisible,
    deleteDialog,
    resetForm,
    openDialog,
    confirmDelete,
    deleteItem,
    fetchItems,
  }
}
